// import React, { useEffect, useState } from "react";
// import { Route, Routes } from "react-router-dom";
// import PublicRoute from "../protectedRoute/publicRoute";
// import RouteVerification from "../common/routeVerification";
// import Cookies from 'js-cookie';
// import CandidateRoutes from "./candidateRoutes";
// import NotFound from "../common/notfound";
// import setAuthToken from "../utils/setAuthToken";
// import { store } from '../redux/store';
// import authActions from "../redux/auth/actions";
// import VerifyEmailRedirection from "../common/verification/verifyEmailRedirection";
// import VerifiedEmailPage from "../common/verification/verifiedEmailPage";
// import { PiArrowCounterClockwiseDuotone } from "react-icons/pi";
// import { useDispatch, useSelector } from "react-redux";
// import candidatesActions from "../redux/candidates/actions";
// import ResetPasswordFaillure from "../common/verification/resetPasswordFaillure";


// if (localStorage.getItem('mhet_cnd_token')) {
//   setAuthToken(localStorage.getItem('mhet_cnd_token'));
//   store.dispatch({ type: authActions.CANDIDATE_TOKEN_VERIFY });
// };

// const AppRoutes = () => {
// const [count,setCount]  = useState(0);
// const dispatch = useDispatch();
// const { candidateTokenDetails } = useSelector(
//   (state) => state.authReducer
// );

//   useEffect(() => {
//     if (localStorage.getItem('mhet_cnd_project') && window.location.pathname === '/') {
//       if (localStorage.getItem('mhet_cnd_token')) {
//         window.location.href = `${`/${localStorage.getItem('mhet_cnd_project')}/home`}`;
//       } else {
//         window.location.href = `${`/${localStorage.getItem('mhet_cnd_project')}/`}`;
//       };
//     }else if((window.location.pathname === '/mhcet/home' || window.location.pathname === '/mhcet/login') && !localStorage.getItem('mhet_cnd_project')){
//  window.location.reload();
//             localStorage.setItem('mhet_cnd_project', "mhcet", { expires: 7 });
//     }
    
//   }, []);


 
// useEffect(()=>{
  
  
//   const int = setInterval(() => {
//     dispatch({ type: authActions.CHECK_KEYCLOAK_SID });
//   }, 9000);

//   // Clear the interval if candidateTokenDetails is null or undefined
//   if (!candidateTokenDetails?.candidateid) {
//     clearInterval(int);
//   }

//   // Cleanup interval on component unmount or dependency change
//   return () => clearInterval(int);

// },[candidateTokenDetails?.candidateid])

//     // candidateTokenDetails?.candidateid ? c
    
//     // startInterval(() => {
//     //       dispatch({type:authActions.CHECK_KEYCLOAK_SID})
//     //     },9000)


// return (
//     <>
//       <Routes>
//         <Route path="/" element={<PublicRoute><RouteVerification /></PublicRoute>} />
//         <Route path="/mhcet" element={<PublicRoute><RouteVerification /></PublicRoute>} />
//         {/* <Route path="/mhcet" element={<PublicRoute><RouteVerification /></PublicRoute>} /> */}
//         <Route path="/candidate" element={<PublicRoute><RouteVerification /></PublicRoute>} />
//         <Route path="/candidate/email-verification" element={<PublicRoute><VerifyEmailRedirection /></PublicRoute>} />
//         <Route path="/candidate/email-verification-status" element={<PublicRoute><VerifiedEmailPage /></PublicRoute>} />
//         <Route path="/candidate/reset-password-failure" element={<PublicRoute><ResetPasswordFaillure/></PublicRoute>} />
//         <Route path="/*" element={<PublicRoute><NotFound /></PublicRoute>} />
//         <Route path={localStorage.getItem('mhet_cnd_project') ? `${localStorage.getItem('mhet_cnd_project')}/*` : '/404'} element={<CandidateRoutes />} />
//       </Routes>
//     </>
//   );
// };

// export default AppRoutes;

import keycloakService from "../modules"; 
import React, { useEffect, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import PublicRoute from "../protectedRoute/publicRoute";
import RouteVerification from "../common/routeVerification";
import Cookies from 'js-cookie';
import CandidateRoutes from "./candidateRoutes";
import NotFound from "../common/notfound";
import setAuthToken from "../utils/setAuthToken";
import { store } from '../redux/store';
import authActions from "../redux/auth/actions";
import VerifyEmailRedirection from "../common/verification/verifyEmailRedirection";
import VerifiedEmailPage from "../common/verification/verifiedEmailPage";
import { PiArrowCounterClockwiseDuotone } from "react-icons/pi";
import { useDispatch, useSelector } from "react-redux";
import candidatesActions from "../redux/candidates/actions";
import ResetPasswordFaillure from "../common/verification/resetPasswordFaillure";
import LandingPage from '../pages/landingPage';
import Header from "../layouts/header";
import axios from "axios";
import { API_URL } from "../utils/constants";


const AppRouter = () => {
  const location = useLocation();


  // useEffect(()=>{
  //   //   const Component = keycloakService.getIsAuthenticated() ? LandingPage : VerifiedEmailPage;
  //   //   keycloakService.getIsAuthenticated() &&   setAuthToken(keycloakService?.getToken())  
  //   // //  const setProject = 
  //   //  keycloakService.getIsAuthenticated() ?   
  //   //  localStorage.setItem("mhet_cnd_token",keycloakService?.getToken())
  //   //   : Cookies.remove("mhet_cnd_token")
    
      
  //       if(keycloakService.getIsAuthenticated()){
  //         store.dispatch({ type: authActions.CANDIDATE_TOKEN_VERIFY });
  //         localStorage.setItem('mhet_cnd_project','mhcet') 
  //         localStorage.setItem("mhet_cnd_token",keycloakService?.getToken())
  //         setAuthToken(keycloakService?.getToken()) 
  //         store.dispatch({type:authActions.CANDIDATE_TOKEN_VERIFY})
  //       }else{
  //         // Cookies.remove('mhet_cnd_project') 
  //         Cookies.remove("mhet_cnd_token")
  //       }
  
  //   },[]);
  
  

  // const setCookies = async () => {
  //   try {
  //     const token = keycloakService?.getToken();
  //     const email = keycloakService?.getUserInfo('email');
  //     const mobileNo = keycloakService?.getUserInfo('phone_number');
      
  //     const response = await axios.post(
  //       `${API_URL}/set-cookies`,
  //       {
  //         token,
  //         email,
  //         mobileNo
  //       },
  //       {
  //         withCredentials: true,  
  //       }
  //     );
         
  //   } catch (error) {
  //     console.error('Error setting cookies:', error);
  //   }
  // };
  

  useEffect(()=>{
  //   const Component = keycloakService.getIsAuthenticated() ? LandingPage : VerifiedEmailPage;
  //   keycloakService.getIsAuthenticated() &&   setAuthToken(keycloakService?.getToken())  
  // //  const setProject = 
  //  keycloakService.getIsAuthenticated() ?   
  //  localStorage.setItem("mhet_cnd_token",keycloakService?.getToken())
  //   : Cookies.remove("mhet_cnd_token")
  // console.log('tetstttstst ---');

    
      if(keycloakService.getIsAuthenticated()){
        const token = keycloakService.getToken();

        store.dispatch({ type: authActions.CANDIDATE_TOKEN_VERIFY });
        localStorage.setItem('mhet_cnd_project','mhcet',{secure: true,sameSite: 'Strict'}) 
        localStorage.setItem("mhet_cnd_token",token,{secure: true,sameSite: 'Strict'})
        setAuthToken(token,{secure: true}) 
        store.dispatch({type:authActions.CANDIDATE_TOKEN_VERIFY})
        localStorage.setItem("mhet_mst_token",token,{secure: true,sameSite: 'Strict'})
        setAuthToken(token,{secure: true}) 
        store.dispatch({type:authActions.CANDIDATE_TOKEN_VERIFY})
        localStorage.setItem("mhet_cnd_email", keycloakService?.getUserInfo('email'),{secure: true,sameSite: 'Strict'})
        localStorage.setItem("mhet_cnd_mobileno", keycloakService?.getUserInfo('phone_number'),{secure: true,sameSite: 'Strict'})
        // localStorage.setItem('uploaddetails', 'true',{secure: true,sameSite: 'Strict'})
        localStorage.setItem("mhet_cnd_mobileno_verified", true,{secure: true,sameSite: 'Strict'});
        localStorage.setItem("mhet_cnd_email_verified", false,{secure: true,sameSite: 'Strict'});
        localStorage.setItem("mhet_cnd_mobileno_otp", false,{secure: true,sameSite: 'Strict'});


        

        // setCookies();
      }else{
        // Cookies.remove('mhet_cnd_project') 
        localStorage.removeItem("mhet_cnd_token")
      }

  },[location.pathname]);


  
  return (
    <Routes>
      <Route path="/" element={<LandingPage/>} />
      {/* <Route path="/candidate" element={<PublicRoute><RouteVerification /></PublicRoute>} /> */}
      <Route path={
        localStorage.getItem('mhet_cnd_project') ? `${localStorage.getItem('mhet_cnd_project')}/*` : 
      'mhcet/*'} element={<CandidateRoutes />} />
 {/* <Route path="*" element={<LandingPage/>} /> */}
    </Routes>
  );
};

export default AppRouter;